import $ from 'jquery';
import store from './applied-filters-store';

function renderPills(filters) {
  const pillContainer = document.getElementById('selected-filters');
  const filteredText = document.getElementById('filtered-text');
  const filtersContainer = document.querySelector('.filters-container');

  if (!pillContainer || !filteredText) return;

  // Clear pills area
  pillContainer.innerHTML = '';

  // Remove clear button ONLY from the container we append into
  filtersContainer?.querySelector('.clear-btn')?.remove();

  if (!filters.length) {
    filteredText.classList.add('u-hide');
    return;
  }

  const ul = document.createElement('ul');
  ul.className = 'horizontal-scroll__item-wrap u-margin-b--none';

  filters.forEach((f) => {
    const li = document.createElement('li');
    li.className = 'horizontal-scroll__item horizontal-scroll__item--basis-none';

    const pill = document.createElement('div');
    pill.className = 'pill-button pill-button--light-grey';

    const span = document.createElement('span');
    span.textContent = f.label;

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'u-margin-l--xs js-applied-filter-remove';
    closeBtn.setAttribute('data-filter-key', f.key);
    closeBtn.innerHTML = `
      <span class="icon icon--x">
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
          <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z"></path>
        </svg>
      </span>`;

    pill.appendChild(span);
    pill.appendChild(closeBtn);
    li.appendChild(pill);
    ul.appendChild(li);
  });

  pillContainer.appendChild(ul);

  const clearBtn = document.createElement('button');
  clearBtn.className = 'clear-btn pill-button pill-button--black u-white-space--nowrap u-margin-l--lg js-applied-filters-clear';
  clearBtn.textContent = 'Clear Filters';

  filtersContainer?.appendChild(clearBtn);
  filteredText.classList.remove('u-hide');
}

// Subscribe (namespaced so it never stacks)
$(document)
  .off(`${store.EVT}.appliedFiltersPills`)
  .on(`${store.EVT}.appliedFiltersPills`, (_, filters) => renderPills(filters));

// Remove pill (delegated)
$(document)
  .off('click.appliedFilters', '.js-applied-filter-remove')
  .on('click.appliedFilters', '.js-applied-filter-remove', function () {
    const key = $(this).attr('data-filter-key');
    if (!key) return;

    const removed = store.getAll().find((f) => f.key === key);
    store.remove(key);

    if (removed?.source === 'sidebar' && removed.checkboxId) {
      $('#multi-select-leftnav-container')
        .find(`#${CSS.escape(removed.checkboxId)}`)
        .prop('checked', false)
        .trigger('change');
    }

    if (removed?.source === 'smartModal') {
      $(document).trigger('smartFilters:remove', [removed]);
    }
  });

$(document)
  .off('click.appliedFilters', '.js-applied-filters-clear')
  .on('click.appliedFilters', '.js-applied-filters-clear', function () {
    const filters = store.getAll();
    store.clear();

    $('#multi-select-leftnav-container')
      .find('input.checkbox__input[type="checkbox"]')
      .prop('checked', false)
      .trigger('change');

    $(document).trigger('smartFilters:clear', [filters]);
  });



// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/applied-filters-pills.js